
import {
  defineComponent, reactive, watch,
} from 'vue';
import Icone from '@/core/components/Icone.vue';
import RequisicaoModal from '@/core/components/Modal/RequisicaoModal.vue';
import { ITelaOperacao } from '@/core/models/ITelaOperacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import { IConhecimentoTransporte } from '@/models/Entidades/Compras/ConhecimentoTransporte/IConhecimentoTransporte';
import SelecionarData from '@/core/components/Tela/SelecionarData.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import ConhecimentoTransporteAbas from '../../../components/Compras/ConhecimentoTransporte/ConhecimentoTransporteAbas.vue';
import SelecionarTransportadora from '@/components/Cadastros/Pessoas/Transportadoras/SelecionarTransportadora.vue';
import SelecionarEmpresa from '@/components/MeuSistema/Empresas/SelecionarEmpresa.vue';

export default defineComponent({
  name: 'ConhecimentoTransporteModal',
  props: {
    visivel: {
      type: Boolean,
    },
    operacao: {
      type: Object as () => ITelaOperacao,
      required: true,
    },
    conhecimentoTransporte: {
      type: Object as () => IConhecimentoTransporte,
    },
    empresa: {
      type: Number,
      required: true,
    },
  },
  components: {
    Icone,
    RequisicaoModal,
    SelecionarData,
    CampoNumerico,
    ConhecimentoTransporteAbas,
    SelecionarTransportadora,
    SelecionarEmpresa,
  },
  emits: ['update:operacao', 'update:visivel', 'update:confirmacao'],
  setup(props, { emit }) {
    const {
      telaBase,
    } = useTelaBase();
    const {
      modalBase,
    } = useModalBase(props, emit);

    const state = reactive({
      conhecimentoTransporte: {} as IConhecimentoTransporte,
    });

    function objetoInicial() {
      state.conhecimentoTransporte = {} as IConhecimentoTransporte;
      if (props.conhecimentoTransporte) {
        state.conhecimentoTransporte = props.conhecimentoTransporte;
      }
      state.conhecimentoTransporte.codigoEmpresa = props.operacao.empresaSelecionada;
    }

    async function AtualizarTela() {
      telaBase.carregando = true;
      objetoInicial();
      if (modalBase.computedVisivel) {
        // Lógica para carregar dados quando o modal se torna visível
      }
      telaBase.carregando = false;
    }

    async function salvar() {
      // Lógica para salvar os dados do formulário
      emit('update:confirmacao', state.conhecimentoTransporte);
    }

    watch(() => props.visivel, async (visivel) => {
      if (visivel) {
        await AtualizarTela();
      }
    });

    return {
      telaBase,
      props,
      modalBase,
      state,
      salvar,
      objetoInicial,
      EPermissaoDados,
    };
  },
});
